module.exports = __webpack_public_path__ + "img/2020-highlander.4015ef14.jpg";